import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=3c8b6ba8&scoped=true"
import script from "./StaffCard.vue?vue&type=script&lang=js"
export * from "./StaffCard.vue?vue&type=script&lang=js"
import style0 from "./StaffCard.vue?vue&type=style&index=0&id=3c8b6ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b6ba8",
  null
  
)

export default component.exports